export default function ({ app, store }) {
  const lang = store?.state?.base?.language || 'en'
  app.i18n.setLocale(lang)
}
